import type { ReactNode } from 'react';

/**
 * The top of every screen: title, one line of explanation, and the primary
 * actions, closed by the 2px rule that separates it from the controls below.
 */
export function PageHeader({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-5 border-b-2 border-line pb-4">
      <div className="flex items-start gap-3">
        {icon !== undefined && (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-accent-soft text-accent-soft-fg">
            {icon}
          </span>
        )}
        <div>
          <h1 className="text-[30px] leading-[1.12] tracking-[-0.015em] text-ink">{title}</h1>
          {description !== undefined && (
            <p className="mt-1.5 max-w-[58ch] text-[13.5px] text-muted">{description}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}
